import {Component, Inject, Input} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';

import {DialogButtonTypesEnum, DialogConfigInterface} from 'appShared/components';
import {ApiError, MarketDataFeedBundleModel, MarketDataFeedInterface, SesService} from '@spa/api';
import {AddFeedExistingBundleForm} from 'appEntries/panel/forms';
import {AlertsService} from 'appShared/services';
import {MarketDataFeedBundleFormErrorStatesEnum, MarketDataFeedsFormErrorStatesEnum} from 'appEntries/panel/enums';
import {MarketDataFeedsAddMessages} from 'appAssets/messages';
import {PanelBaseMarketDataFormDialogComponent} from 'appEntries/panel/dialogs/ses/panel-base-market-data-form-dialog.component';

@Component({
    selector: 'app-market-data-add-feed-exisiting-bundle',
    templateUrl: './market-data-add-feed-exisiting-bundle.component.html',
    styleUrls: ['./market-data-add-feed-exisiting-bundle.component.scss']
})
export class MarketDataAddFeedExistingBundleComponent
    extends PanelBaseMarketDataFormDialogComponent<MarketDataAddFeedExistingBundleComponent> {

    @Input() public feeds: MarketDataFeedInterface[];
    @Input() public bundle: MarketDataFeedBundleModel;
    @Input() public hasViewPricePermission: boolean;

    constructor(
        @Inject(MAT_DIALOG_DATA) public data: {
            config: DialogConfigInterface,
            feeds: MarketDataFeedInterface[],
            bundle: MarketDataFeedBundleModel,
            hasViewPricePermission: boolean
        },
        private readonly sesService: SesService,
        protected alertsService: AlertsService,
        public dialogRef: MatDialogRef<MarketDataAddFeedExistingBundleComponent>,
    ) {
        super(dialogRef, alertsService);
        this.config = data.config;
        this.feeds = data.feeds;
        this.bundle = data.bundle;
        this.hasViewPricePermission = data.hasViewPricePermission;
    }

    initForm(): void {
        this.form = new AddFeedExistingBundleForm(this.sesService, this.feeds, this.bundle);
        this.form.initForm();

        const formChangeSubscription = this.form.formGroup.valueChanges.subscribe((data: object) => {
            const selectedBundleFirstIndex = Object.keys(data).findIndex(
                (key: string) => data[key] > 0
            );
            this.config.buttons.find(button => button.type === DialogButtonTypesEnum.Confirm).hidden = selectedBundleFirstIndex < 0;
        });

        this.subscriptions.push(formChangeSubscription);
    }

    getSuccessFormMessage(): string {
        return MarketDataFeedsAddMessages.MarketDataFeedBundleUpdateSucceed.message;
    }

    getErrorMessageByApiError(error: ApiError): string {
        switch (error.status) {
            case MarketDataFeedsFormErrorStatesEnum.CreateMarketDataFeedFailed:
                return MarketDataFeedsAddMessages.MarketDataFeedBundleCreationFailed.message;
            case MarketDataFeedBundleFormErrorStatesEnum.CreateMarketDataFeedBundleFailedNoFeed:
                return MarketDataFeedsAddMessages.CreateMarketDataFeedBundleFailedNoFeed.message;
            default:
                return MarketDataFeedsAddMessages.UnknownError.message;
        }
    }

}
